import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Observable, of, Subject } from 'rxjs';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { GlobalService } from 'src/app/global.service';
import { Service } from 'src/app/services';
import { LoadingScreenService } from 'src/app/services/loading-screen/loading-screen.service';
@Component({
  selector: 'app-shipping-address',
  templateUrl: './shipping-address.component.html',
  styleUrls: ['./shipping-address.component.sass']
})
export class ShippingAddressComponent implements OnInit {
  @Input() addressValidation: any;
  @Input() indexTab: any;
  @Input() selectsToDisplay: any;
  @Input() itemsCart: any;
  @Output() closeTab = new EventEmitter<number>();
  @Output() validate = new EventEmitter<boolean>();
  @Output() selectsToDisplayOut = new EventEmitter<any>();
  public signupFormUser: FormGroup;
  public validator: boolean = false;
  public checkterms: boolean = false;
  public checktermsDevolution: boolean = false;
  public token: any;
  public changeAddress: boolean = false;
  public showTerms: boolean = false;
  public checkInfoHouse: boolean = false;
  public noValid: boolean = true;
  constructor(private services: Service, private builder: FormBuilder, public global: GlobalService,public dialog: MatDialog, private loadingScreenService: LoadingScreenService) {
    this.signupFormUser = this.builder.group({
      name: ['', Validators.required],
      lastName: ['', Validators.required],
      phone: ['', Validators.compose([Validators.minLength(10), Validators.maxLength(10), Validators.required])],
      email: ['', Validators.compose([Validators.email, Validators.required])],
      addres: ['', Validators.required],
      addres2: [''],
      zip: ['', [this.zipCodeValidator]],
      city: ['', Validators.required],
      indications: [''],
      phone2: [''],
      state: ['PR', Validators.required]
    });
  }
  ngOnInit() {
    this.token = sessionStorage.getItem("token");
    this.global.tokenShop=sessionStorage.getItem("tokenShop");

  }
  ngOnChanges(changes: SimpleChanges) {
    if (changes["addressValidation"] != undefined) {
      this.changeAddress = changes["addressValidation"].currentValue;
      if (this.changeAddress == true) {
        this.validationAddres();
      }
    }
    for (let i = 0; i < this.itemsCart.products.length; i++) {
        if (this.itemsCart.products[i].equipment == true && this.itemsCart.products[i].installments > 0) {
          this.showTerms = true;
        }
      }
  }
  nextTab() {

    if (this.signupFormUser.status == "INVALID") {
      this.validator = false
    }
    else if (this.signupFormUser.status == "VALID") {
      this.validator = true
    }
    this.closeTab.emit();
  }
  validationAddres() {
    if (this.signupFormUser.status == "VALID") {
      this.validate.emit(true);
    }
    else {
      this.validate.emit(false);
    }
    if (this.signupFormUser.get("name")?.status == "INVALID") {
      this.global.notif(" Por favor, coloque el nombre del titúlar.");
      return
    }
    else if (this.signupFormUser.get('lastName')?.status == "INVALID") {
      this.global.notif(" Por favor, coloque su apellido.");
      return
    }
    else if (this.signupFormUser.get('phone')?.status == "INVALID") {
      this.global.notif(" Por favor, coloque su número de teléfono");
      return
    }
    else if (this.signupFormUser.get('email')?.errors && this.signupFormUser.get('email')?.value != "") {
      this.global.notif(" Ingrese un email valido");
      return
    }
    else if (this.signupFormUser.get('email')?.status == "INVALID") {
      this.global.notif(" Por favor, coloque su email");
      return
    }
    else if (this.signupFormUser.get('addres')?.status == "INVALID") {
      this.global.notif(" Por favor, coloque su dirección");
      return
    }
    else if (this.signupFormUser.get('zip')?.status == "INVALID") {
      this.global.notif(" Por favor, coloque un codigo zip");
      return
    }
     else if (this.checkterms == false || this.checktermsDevolution == false) {
      this.checktermsGeneral()
    }
    else {
      if (this.changeAddress == true) {
        this.nextTab();
      }
      else {
        this.loadingScreenService.startLoading();
        this.services.createAddress(
          this.global.tokenShop,
          this.signupFormUser.get("name")?.value + " " + this.signupFormUser.get('lastName')?.value,
          this.signupFormUser.get('email')?.value,
          this.signupFormUser.get('addres')?.value,
          this.signupFormUser.get('addres2')?.value,
          this.signupFormUser.get("city")?.value,
          "PR",
          this.signupFormUser.get("zip")?.value + '-0000',
          this.signupFormUser.get("indications")?.value,
          this.signupFormUser.get('phone')?.value,
          1
        ).subscribe((data: any) => {
          if (data.hasError == false) {
            this.loadingScreenService.stopLoading();
            this.selectsToDisplay[this.indexTab] = ' |   ' + this.signupFormUser.get('addres')?.value + ', ' + this.signupFormUser.get("city")?.value + '  ' + this.signupFormUser.get("zip")?.value;
            this.selectsToDisplayOut.emit(this.selectsToDisplay);
            this.nextTab();
          }
          else {
            this.loadingScreenService.stopLoading();
            this.global.notif(data.errorDesc)
          }
        });
      }
    }

  }
  zipCodeValidator(control: any): { [key: string]: boolean } | null {
    let townFound: boolean = false;
    let listVillages = [
      { label: "Adjuntas", value: "00601" },
      { label: "Adjuntas", value: "00631" },
      { label: "Aguada", value: "00602" },
      { label: "Aguadilla", value: "00603" },
      { label: "Aguadilla", value: "00604" },
      { label: "Aguadilla", value: "00605" },
      { label: "Aguadilla", value: "00690" },
      { label: "Aguas Buenas", value: "00703" },
      { label: "Aibonito", value: "00705" },
      { label: "La Plata", value: "00786" },
      { label: "Añasco", value: "00610" },
      { label: "Angeles", value: "00611" },
      { label: "Arecibo", value: "00612" },
      { label: "Arecibo", value: "00613" },
      { label: "Arecibo", value: "00614" },
      { label: "Arecibo", value: "00616" },
      { label: "Arecibo", value: "00652" },
      { label: "Arecibo", value: "00688" },
      { label: "Arroyo", value: "00714" },
      { label: "Barceloneta", value: "00617" },
      { label: "Barranquitas", value: "00794" },
      { label: "Bayamón", value: "00956" },
      { label: "Bayamón", value: "00957" },
      { label: "Bayamón", value: "00959" },
      { label: "Bayamón", value: "00961" },
      { label: "Bayamón", value: "009606" },
      { label: "Bayamón", value: "00958" },
      { label: "Cabo Rojo", value: "00623" },
      { label: "Boquerón", value: "00622" },
      { label: "Caguas", value: "00725" },
      { label: "Caguas", value: "00727" },
      { label: "Caguas", value: "00726" },
      { label: "Camuy", value: "00627" },
      { label: "Canóvanas", value: "00729" },
      { label: "Canóvanas", value: "00745" },
      { label: "Carolina", value: "00979" },
      { label: "Carolina", value: "00982" },
      { label: "Carolina", value: "00983" },
      { label: "Carolina", value: "00985" },
      { label: "Carolina", value: "00987" },
      { label: "Carolina", value: "00981" },
      { label: "Carolina", value: "00984" },
      { label: "Carolina", value: "00986" },
      { label: "Carolina", value: "00988" },
      { label: "Cataño", value: "00962" },
      { label: "Cataño", value: "00963" },
      { label: "Cayey", value: "00736" },
      { label: "Cayey", value: "00737" },
      { label: "Ceiba", value: "00735" },
      { label: "Ceiba", value: "00742" },
      { label: "Ciales", value: "00638" },
      { label: "Cidra", value: "00739" },
      { label: "Coamo", value: "00769" },
      { label: "Comerio", value: "00782" },
      { label: "Corozal", value: "00783" },
      { label: "Culebra", value: "00775" },
      { label: "Dorado", value: "00646" },
      { label: "Fajardo", value: "00738" },
      { label: "Fajardo", value: "00740" },
      { label: "Florida", value: "00650" },
      { label: "Guánica", value: "00653" },
      { label: "Guánica", value: "00647" },
      { label: "Guayama", value: "00784" },
      { label: "Guayama", value: "00704" },
      { label: "Guayama", value: "00785" },
      { label: "Guayanilla", value: "00656" },
      { label: "Guaynabo", value: "00965" },
      { label: "Guaynabo", value: "00966" },
      { label: "Guaynabo", value: "00968" },
      { label: "Guaynabo", value: "00971" },
      { label: "Guaynabo", value: "00970" },
      { label: "Guaynabo", value: "00969" },
      { label: "Gurabo", value: "00778" },
      { label: "Hatillo", value: "00659" },
      { label: "Hormigueros", value: "00660" },
      { label: "Humacao", value: "00791" },
      { label: "Humacao", value: "00792" },
      { label: "Humacao", value: "00741" },
      { label: "Isabela", value: "00662" },
      { label: "Jayuya", value: "00664" },
      { label: "Juana Díaz", value: "00795" },
      { label: "Juncos", value: "00777" },
      { label: "Lajas", value: "00667" },
      { label: "Lares", value: "00669" },
      { label: "Las Marías", value: "00670" },
      { label: "Las Piedras", value: "00771" },
      { label: "Loíza", value: "00772" },
      { label: "Luquillo", value: "00773" },
      { label: "Manatí", value: "00674" },
      { label: "Maricao", value: "00606" },
      { label: "Maunabo", value: "00707" },
      { label: "Mayaguez", value: "00680" },
      { label: "Mayaguez", value: "00682" },
      { label: "Mayaguez", value: "00681" },
      { label: "Moca", value: "00676" },
      { label: "Morovis", value: "00687" },
      { label: "Naguabo", value: "00718" },
      { label: "Rio Blanco", value: "00744" },
      { label: "Naranjito", value: "00719" },
      { label: "Orocovis", value: "00720" },
      { label: "Patillas", value: "00723" },
      { label: "Peñuelas", value: "00624" },
      { label: "Ponce", value: "00716" },
      { label: "Ponce", value: "00717" },
      { label: "Ponce", value: "00728" },
      { label: "Ponce", value: "00730" },
      { label: "Ponce", value: "00731" },
      { label: "Ponce", value: "00733" },
      { label: "Ponce", value: "00780" },
      { label: "Ponce", value: "00715" },
      { label: "Ponce", value: "00732" },
      { label: "Ponce", value: "00734" },
      { label: "Quebradillas", value: "00678" },
      { label: "Rincón", value: "00677" },
      { label: "Río Grande", value: "00721" },
      { label: "Río Grande", value: "00745" },
      { label: "Sabana Grande", value: "00637" },
      { label: "Salinas", value: "00751" },
      { label: "San Germán", value: "00683" },
      { label: "San Germán", value: "00636" },
      { label: "San Juan", value: "00921" },
      { label: "San Juan", value: "00923" },
      { label: "San Juan", value: "00924" },
      { label: "San Juan", value: "00929" },
      { label: "San Juan", value: "00915" },
      { label: "San Juan", value: "00916" },
      { label: "San Juan", value: "00920" },
      { label: "San Juan", value: "00909" },
      { label: "San Juan", value: "00910" },
      { label: "Fort Buchanan", value: "00934" },
      { label: "San Juan", value: "00936" },
      { label: "San Juan", value: "00917" },
      { label: "San Juan", value: "00919" },
      { label: "San Juan", value: "00911" },
      { label: "San Juan", value: "00912" },
      { label: "San Juan", value: "00913" },
      { label: "San Juan", value: "00914" },
      { label: "San Juan", value: "00940" },
      { label: "San Juan", value: "00901" },
      { label: "San Juan", value: "00902" },
      { label: "San Juan", value: "00906" },
      { label: "San Juan", value: "00925" },
      { label: "San Juan", value: "00926" },
      { label: "San Juan", value: "00927" },
      { label: "San Juan", value: "00928" },
      { label: "San Juan", value: "00930" },
      { label: "San Juan", value: "00907" },
      { label: "San Juan", value: "00908" },
      { label: "San Juan", value: "00931" },
      { label: "San Juan", value: "00933" },
      { label: "San Lorenzo", value: "00754" },
      { label: "San Sebastián", value: "00685" },
      { label: "Santa Isabel", value: "00757" },
      { label: "Toa Alta", value: "00953" },
      { label: "Toa Alta", value: "00954" },
      { label: "Toa Baja", value: "00949" },
      { label: "Toa Baja", value: "00950" },
      { label: "Toa Baja", value: "00951" },
      { label: "Toa Baja", value: "00952" },
      { label: "Trujillo Alto", value: "00976" },
      { label: "Trujillo Alto", value: "00977" },
      { label: "Saint Just", value: "00978" },
      { label: "Utuado", value: "00641" },
      { label: "Utuado", value: "00611" },
      { label: "Vega Alta", value: "00692" },
      { label: "Vega Baja", value: "00693" },
      { label: "Vega Baja", value: "00694" },
      { label: "Vieques", value: "00765" },
      { label: "Villalba", value: "00766" },
      { label: "Yabucoa", value: "00767" },
      { label: "Yauco", value: "00698" }
    ];
    for (let i = 0; i < listVillages.length; i++) {
      if (listVillages[i].value == control.value) {
        townFound = true;
        control.parent.controls["city"].value = listVillages[i].label;
      }
    }
    if (townFound != true) {
      if (control.parent != null && control.parent != undefined) {
        control.parent.controls["city"].value = "";
      }
      return { 'zip': true };
    }
    return null;
  }
  checktermsGeneral() {
    if (this.checktermsDevolution == false) {
      let title = 'Politicas de Devolución';
      let templetePath = 'assets/template/return-policy.html';
       this.global.showTerms('template', title, templetePath, true).subscribe(data => {
         if (data == 'continue') {
           this.checktermsDevolution = true;
        }
     });
    }
    if (this.checkterms == false) {
      let title = 'Términos de Contrato';
      let templetePath = 'assets/template/terms-credit.html';
       this.global.showTerms('template', title, templetePath, true).subscribe(data => {
         if (data == 'continue') {
         this.checkterms = true;
        }
       });
    }
  }
  pupOpTermns() {
    let title = 'Términos de Contrato';
    let templetePath = 'assets/template/terms-credit.html';
     this.global.showTerms('template', title, templetePath, true).subscribe(data => {
       if (data == 'continue') {
         this.checkterms = true
       }
     });
  }
  pupOpTermnsReturn() {
    let title = 'Politicas de Devolución';
    let templetePath = 'assets/template/return-policy.html';
     this.global.showTerms('template', title, templetePath, true).subscribe(data => {
       if (data == 'continue') {
         this.checktermsDevolution = true;
       }
     });
  }
  fillData() {
    this.checkInfoHouse=!this.checkInfoHouse;
    let info:any = JSON.parse(sessionStorage.getItem("accountInfo"));
    if (this.checkInfoHouse == true) {
      let phone:string="";
      if(sessionStorage.getItem("currentSuscriber")!=null){
        phone=(atob(sessionStorage.getItem("currentSuscriber")));
      }
      this.signupFormUser.setValue({
        name: info.firstNameField,
        lastName: info.lastNameField,
        phone: phone,
        email: info.emailField,
        addres: info.addressLinesField.line1Field,
        addres2: info.addressLinesField.line2Field,
        zip: "",
        city: "",
        indications: "",
        phone2: "",
        state: 'PR'
      });
      this.signupFormUser.controls['zip'].setValue(info.zIPField);
    }
    else {
      this.validate.emit(false);
      this.signupFormUser.setValue({
        name: '',
        lastName: '',
        phone: '',
        email: '',
        addres: '',
        addres2: '',
        zip: '',
        city: '',
        indications: '',
        phone2: '',
        state: 'PR'
      });
    }
  }
}
